import styled from 'styled-components';
import { ICON_CLASS } from '../../Icons/tokens';
import { TabsTrigger } from '../../Tabs';
import { theme } from '../../theme';
import { NoWrapStackItemBase, StyledContentIcon } from '../sharedStyled';
import { tokens } from '../tokens';
export const VerticalStepBase = styled(TabsTrigger)`
  margin: 0;
  padding: 0;
  box-shadow: none;
  border: none;
  height: auto;
  background: ${theme.colors.transparent};

  &:focus {
    box-shadow: none;
  }

  ${({ $iconType, $state })=>$iconType === 'featuredIcon' && $state === 'pending' && `
      opacity: 0.5;
    `}

  &&& {
    gap: ${tokens.StepList.vertical.spacing.gap};
  }
`;
export const VerticalConnectorWrapper = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  flex-direction: column;
  height: auto;
  gap: ${tokens.StepList.vertical.spacing.gap};
`;
/**
 * The vertical connector line that extends under the icon circle.
 */ export const VerticalConnector = styled.div`
  width: ${tokens.StepList.vertical.connector.width};
  height: calc(
    100% - ${({ $iconType })=>$iconType === 'default' ? tokens.StepList.vertical.iconSize : theme.sizes.x48} - 2 *
      ${theme.spaces.x4}
  );
  border-radius: ${tokens.StepList.vertical.connector.radius};

  background-color: ${({ $state, $connector })=>$state === 'completed' && $connector ? tokens.StepList.vertical.connectorColor.default : theme.colors.transparent};

  ${({ $iconType, $connector, $state })=>$iconType === 'featuredIcon' && `
      background-color: ${$state !== 'pending' && $connector ? tokens.StepList.vertical.connectorColor.featuredIcon : theme.colors.transparent};
    `}
`;
/**
 * The circle icon background in vertical mode (pending, active, completed).
 */ export const VerticalStepIconBase = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: ${tokens.StepList.vertical.iconSize};
  min-height: ${tokens.StepList.vertical.iconSize};
  background-color: ${tokens.StepList.vertical.background};
  border-radius: ${theme.radius.full};

  ${({ $state })=>$state === 'active' && `
      box-shadow: ${tokens.StepList.vertical.Icon.boxShadow};
      border-radius: ${theme.radius.full};
    `}

  ${VerticalStepBase}:focus-visible & {
    box-shadow: ${tokens.StepList.vertical.Icon.focusedBoxShadow};
  }

  ${({ $state })=>$state === 'completed' && `
        .${ICON_CLASS} {
        color: ${theme.colors.brand600};
      }
    `}

  ${StyledContentIcon} {
    ${({ $state })=>$state === 'pending' && `
        border: 2px solid ${theme.colors.gray200};
        border-radius: ${theme.radius.full};
        color: ${theme.colors.white};
        circle {
          fill: ${theme.colors.gray300};
        }
      `}
  }
`;
/**
 * Text container for the vertical step (title & details).
 */ export const VerticalNoWrapStackItem = styled(NoWrapStackItemBase)`
  gap: ${tokens.StepList.vertical.spacing.contentGap};

  ${({ $orientation, $iconType })=>$orientation === 'vertical' && `
      padding: ${$iconType === 'default' ? tokens.StepList.vertical.spacing.defaultPadding : tokens.StepList.vertical.spacing.featuredPadding};
    `}
`;
